export default {
  api: process.env.NODE_ENV === 'production' ? '/bd' : '/bd',
  order: process.env.ORDER || ''
};
